var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#2c3640;}.c{fill:#0066b1;}.d{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 175,
    height: 175,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-307.593 -759.593)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, 307.59, 759.59)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 100,
    height: 100,
    rx: 50,
    transform: "translate(37.5 37.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(363.097 815.097)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-163.975,358.729q.012,2.829.024,5.657c-.625,4-2.021,7.488-6.2,9.019a1.381,1.381,0,0,0-.937,1.274c-1.105,6.493-5.847,9.1-11.492,10.69a20.032,20.032,0,0,1-4.433.768c-2.376.112-4.424.36-6.251,2.382-1.766,1.954-5.021,1.4-6.944-.583a5.4,5.4,0,0,1-.424-6.891c1.6-2.116,5.032-3.143,6.851-1.349,2.361,2.328,4.825,1.459,7.336,1.312a16.248,16.248,0,0,0,3.562-.772c5.074-1.493,6.879-3.913,6.828-9.182-.074-7.67.085-15.344-.429-23.006-.535-7.968-7.7-15.882-15.636-17.244-11.361-1.95-20.966,4.234-23.744,15.276a21.41,21.41,0,0,0-.443,4.906c-.111,6.6-.164,13.192-.251,19.787-.033,2.519-.951,3.348-3.435,3.157-4.871-.374-7.7-3.483-8.7-9.55l.02-5.647c.717-4.078,2.288-7.552,6.6-8.942.771-.249.726-.7.785-1.27,1.2-11.618,8.375-19.877,19.644-22.633,14.224-3.477,29.415,7.671,30.284,22.211.037.625-.293,1.355.784,1.7C-166.256,351.168-164.663,354.634-163.975,358.729Z",
    transform: "translate(228.694 -325.248)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.696 22.322)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-165.18,392.757a11.086,11.086,0,0,1,.42-3.4,6.515,6.515,0,0,1,1.505-2.407,9.471,9.471,0,0,0,1.528-2.078,3.8,3.8,0,0,0,.382-1.635q0-2.552-1.65-2.552a1.448,1.448,0,0,0-1.222.7,3.424,3.424,0,0,0-.52,1.895h-4.324a6.333,6.333,0,0,1,1.658-4.6A5.941,5.941,0,0,1-163,377.05a5.953,5.953,0,0,1,4.415,1.581,6,6,0,0,1,1.574,4.423,7.068,7.068,0,0,1-1.94,4.615l-1.268,1.436a4.661,4.661,0,0,0-.886,1.551,7.578,7.578,0,0,0-.29,2.1Zm-.4,4.676a2.279,2.279,0,0,1,.665-1.7,2.3,2.3,0,0,1,1.688-.657,2.3,2.3,0,0,1,1.711.665,2.3,2.3,0,0,1,.657,1.689,2.338,2.338,0,0,1-.642,1.681,2.274,2.274,0,0,1-1.726.672,2.256,2.256,0,0,1-1.712-.672A2.338,2.338,0,0,1-165.578,397.433Z",
    transform: "translate(169.061 -377.05)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadPhoneIcon);
export default __webpack_public_path__ + "static/media/headPhoneIcon.642471830bef3003d3f97b1f3b0f93bb.svg";
export { ForwardRef as ReactComponent };